// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8ae46245","498":"6e539edc","545":"edadbe1a"}[chunkId] + ".chunk.js";
};